import { CommonResponse } from "@gtpl/shared-models/masters";
import connection from "./connection";
import axios from "axios";
import { ExpensesModelDto, ExpensesModelDtoReq, ExpensesResponseModel } from "libs/shared-models/finance/src";

export class ExpensesServices{
  
    URL = connection.DEPLOY_URL + '/expenses';

    async UploadExcel(req:ExpensesModelDtoReq): Promise<ExpensesResponseModel> {
        return await axios.post(this.URL + '/ExpensesService',req)
            .then(res => {
                return res.data
            })
    }

    async getExpenses(): Promise<ExpensesResponseModel> {
        return await axios.post(this.URL + "/getExpenses")
        .then(res => {
            return res.data
          })
    }
}